import { render, staticRenderFns } from "./FullWidthTitle.vue?vue&type=template&id=d2bfba8a"
import script from "./FullWidthTitle.vue?vue&type=script&lang=js"
export * from "./FullWidthTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports